import styled from 'styled-components';

export const StyledMapWrapper = styled.div`
  position: relative;
  height: ${props => (!props.presentMapEnabled ? 'calc(100vh - 64px)' : '100vh')};
  width: 100%;
`;

export const ChoroplethLegend = styled.div`
  position: absolute;
  right: 16px;
  bottom: 20px;
  z-index: 5;
  min-width: 220px;
  padding: 14px 14px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
  backdrop-filter: blur(10px);
`;

export const ChoroplethLegendRamp = styled.div`
  height: 12px;
  width: 100%;
  border-radius: 999px;
  background: ${props => props.background};
  box-shadow: inset 0 0 0 1px rgba(17, 24, 39, 0.08);
`;

export const ChoroplethLegendScale = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  font-size: 12px;
  color: #1f2937;
`;
